import { localStorage } from '../../../utils/storageUtils';
import { InviteFormValues } from '../models/inviteForm';

export const getStoredInvite = () => localStorage.getItem('inviteForm');

export const updateStoredInvite = (updateFn: (current: InviteFormValues) => InviteFormValues) =>
  localStorage.setItem('inviteForm', updateFn(localStorage.getItem('inviteForm')));

export const clearStoredInvite = () => localStorage.removeItem('inviteForm');
